import React from "react";
import { userprofile } from "../../Model/Users"; //Include Home
import {
    Link
} from "react-router-dom";

import { isMobile } from "react-device-detect";
import { withRouter, VirsionCheck } from "../../Helpers/Common"; //Include Home
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { motion } from "framer-motion";
import BarLoader from "react-spinners/BarLoader";

var SVGIcon = "";
var ImageData = "";
var name = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

class Manageprofiledesk extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            VirsionCheckData: [],
            VirsionCheckDataloaded: false,
            DataisLoaded: false,
            ProfileData: false,
        };
    }

    componentDidMount() {

        this.setState({
            VirsionCheckData: this.props.versioncheck,
            VirsionCheckDataloaded: true,
            DataisLoaded: true,
            ProfileData: this.props.profile,
        });
    }

    /*-------Logout-------*/
    backbtn() {
        this.props.navigate("/profile");
    }

    render() {

        if (this.state.VirsionCheckDataloaded == false) {
            // return <div className="loader"></div>;
            return <div className="loader"><BarLoader color="#ff000f" /></div>;
        } else {

            var MetaData = JSON.parse(this.state.VirsionCheckData.data).data.page.signup;
            var UserprofileData = this.state.ProfileData;

            if (UserprofileData.errorcode == "1008") {
                this.props.navigate("/createaccount");
            }

            return (
                <>
                    <motion.div
                        className=""
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 1 }}
                        key="1"
                    >
                        <main>
                            <main className="setting-main dD-block">
                                <div className="profile-back-desk">
                                    <Link to="/">
                                        <div className="docubayBack white">
                                            <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                                        </div>
                                    </Link>
                                </div>
                                <section className="mb-0">
                                    <div className="temp60">
                                        <div className="temp60-inn">
                                            <img src={ImageData["profilePic.jpg"]} alt="DocuBay" className="w-100 dD-none" />
                                            <div className="temp60-area">
                                                <div className="temp60-profPic">
                                                    <img
                                                        src={SVGIcon["mask.svg"]}
                                                        alt="Profile Pic"
                                                        className="temp60-profImg"
                                                    />
                                                    {/* <div className="temp60-profCam"><img src={SVGIcon["camera2.svg"]} alt="" /></div> */}
                                                </div>
                                                <h5>{UserprofileData.name}</h5>
                                                {/* <h6 className="dD-none">amaisharma@gmail.com</h6>
                          <h6 className="dD-none">{UserprofileData.user_mobile}</h6> */}
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <section className="mb-0">
                                    <div className="temp46-D dD-block">
                                        <div className="temp46-AreaD">
                                            <div className="temp46-InnD">
                                                <h5>Name</h5>
                                                <p>{UserprofileData.name}</p>
                                            </div>
                                            <div className="temp46-InnD-right">
                                                {UserprofileData.name == "" && (
                                                    <Link to="/add-name">
                                                        Add Name
                                                    </Link>
                                                )}
                                                {UserprofileData.name != "" && (
                                                    <Link to="/change-name">
                                                        Change name
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                        <div className="temp46-AreaD">
                                            <div className="temp46-InnD">
                                                <h5>Email Address</h5>
                                                <p>{UserprofileData.user_email}</p>
                                            </div>
                                            <div className="temp46-InnD-right">
                                                {UserprofileData.user_email == "" && (
                                                    <Link to="/add-email">
                                                        Add Email Address
                                                    </Link>
                                                )}
                                                {UserprofileData.user_email != "" && (
                                                    <Link to="/change-email">
                                                        Change Email Address
                                                    </Link>
                                                )}
                                                {UserprofileData.is_verified_email == "" && UserprofileData.user_email != "" && (
                                                    <Link to="/verify-email">
                                                        Verify Email Address
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                        <div className="temp46-AreaD">
                                            <div className="temp46-InnD">
                                                <h5>Phone No.</h5>
                                                <p>{UserprofileData.country_code} {UserprofileData.mobile_number}</p>
                                            </div>
                                            <div className="temp46-InnD-right">
                                                {UserprofileData.user_mobile != "" && (
                                                    <Link to="/change-mobile">
                                                        Change Phone Number
                                                    </Link>
                                                )}

                                                {UserprofileData.is_verified_mobile == "" && UserprofileData.user_mobile != "" && (
                                                    <Link to="/verify-mobile">
                                                        Verify Phone Number
                                                    </Link>
                                                )}

                                                {UserprofileData.user_mobile == "" && (
                                                    <Link to="/add-mobile">
                                                        Add Phone Number
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                        <div className="temp46-AreaD">
                                            <div className="temp46-InnD">
                                                <h5>Password</h5>
                                                <p>...........</p>
                                            </div>
                                            <div className="temp46-InnD-right">
                                                <Link to="/change-password">
                                                    Change Password
                                                </Link>
                                            </div>
                                        </div>
                                        {/* <div className="temp46-AreaD">
                                            <div className="temp46-InnD">
                                                <h5>Detail</h5>
                                                <p>Billing Details</p>
                                            </div>
                                            <div className="temp46-InnD-right">
                                                <a href="billing-details.html">View Detail</a>
                                            </div>
                                        </div> */}
                                        <div className="temp46-AreaD">
                                            <div className="temp46-InnD">
                                                <h5>Device</h5>
                                                <p>Manage Devices</p>
                                            </div>
                                            <div className="temp46-InnD-right">
                                                <Link to="/manage-devices">View Device Activity</Link>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </main>
                        </main>
                        {/* <Mobilemenu active="5" /> */}
                        {/* {isMobile ? <Mobilemenu active="5" /> : <Profilemenu userdata={this.state.userData} />} */}
                    </motion.div>
                </>
            );
        }
    }
}
export default withRouter(Manageprofiledesk);
